<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <el-col :span="24" style="text-align: right">

        <el-pagination layout="prev, pager, next,sizes" :total="searchResult.total" :page-sizes="pageSizes"
          :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load" @size-change="load">
        </el-pagination>
        <!-- Table -->
      </el-col>
    </el-row>
    <el-row>
      <el-table v-loading="loading" :data="searchResult.gateways">
        <el-table-column prop="macAddress" :label="$t('gateway.macAddress')"></el-table-column>
        <el-table-column :label="$t('tree.type')">
          <template slot-scope="scope">
            <span>{{deviceType(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('gateway.status')">
          <template slot-scope="scope">
            <span v-if="
              scope.row.connectionStatus &&
              scope.row.connectionDate
            ">
              <span>{{
              $t(`common.${scope.row.connectionStatus}`)
              }}</span>

              <br />
              <span>{{
              toDisplayDate(scope.row.connectionDate)
              }}</span>
            </span>
            <span v-else> N/A </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t(`gateway.routings`)">
          <template slot-scope="scope">
            <span>
              <el-button size="mini" @click="showAvaliableDevicesDialog(scope)">{{$t(`gateway.availableDevices`)}}
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination layout="prev, pager, next,sizes" :total="searchResult.total" :page-sizes="pageSizes"
          :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load" @size-change="load">
        </el-pagination>
        <!-- Table -->
      </el-col>
    </el-row>
    <el-dialog width="30%" title="Avaliable Devices" :visible.sync="showAvailableDevices">
      <el-table :data="availableDevices" class="border">
        <el-table-column type="index" label="Id"> </el-table-column>
        <el-table-column prop="_id.device" label="device" />
        <el-table-column prop="_id.gateway" label="gateway" />
        <el-table-column prop="rssi" label="rssi" width="100px;" />
      </el-table>
    </el-dialog>
  </div>

</template>



<script>
import { mapState, mapActions } from "vuex";
import preferences from "../util/preferences";
import dayjs from "dayjs";
export default {
  name: "Senseways",
  data() {
    return {
      results: {},
      formLoading: false,
      availableDevices: [],
      showAvailableDevices: false,
      query: {
        macAddress: "",
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
    };
  },
  created() {
    this.getGateways(this.query);
  },

  computed: {
    ...mapState("gateway", ["searchResult", "loading"]),
  },
  methods: {
    deviceType(gateway) {
      //first three octet
      let mac = gateway.macAddress.substring(0, 8);
      switch (mac) {
        case 'CA:B8:25': return this.$t("point.trigger");
        case 'CA:B8:DA': return this.$t("admin.duck");
        default: return 'Senseway';
      }
    },
    showAvaliableDevicesDialog(scope) {
      console.log(scope.row);
      this.availableDevices = scope.row.availableDevices;
      this.showAvailableDevices = true;
    },
    ...mapActions("gateway", [
      "getGateways",
      "updateStatusShadow",
    ]),
    load() {
      this.getGateways(this.query);
    },
    toDisplayDate(timestamp) {
      return dayjs(timestamp).format(preferences().localization.dateFormat);
    },
  },
};
</script>
<style scoped>
.el-dialog {
  margin-top: 15vh !important;
  width: 40% !important;
}

p {
  margin-left: 30px;
}

.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}

.vue-phone-number-input .select-country-container {
  min-width: 100px !important;
  max-width: 100px !important;
}

.el-tooltip__popper {
  max-width: 500px !important;
  width: 400px !important;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}

.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}

.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>